import React, {useContext} from "react";
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";
import {doLogout} from "../../store/actions/UserActions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useDispatch} from "react-redux";
import {faRightFromBracket} from "@fortawesome/free-solid-svg-icons";


const AccountIndex = () => {

    const {currentUser} = useContext(AuthContext);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const doLogoutButton = () =>{
        dispatch(doLogout());
        navigate('/');
    }

    return (
        <div className="container account">
            <div className="hero-container">
                <button className="btn btn-normal" onClick={doLogoutButton}><FontAwesomeIcon icon={faRightFromBracket}/> Log out
                </button>
            </div>
        </div>
    );
}

export default AccountIndex;